import React from 'react';
import { Wrapper } from './style.js';
import FontLoader from '../../FontLoader/FontLoader';
import dynamic from 'next/dynamic';
const PixiContainer = dynamic(() => import('./PixiContainer.js'), {
  ssr: false,
});

const Landing = props => {
  const { next } = props;

  return (
    <Wrapper>
      <FontLoader />
      <PixiContainer />
    </Wrapper>
  );
};

export default Landing;
